<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{'plan.save.as.title.dlg'|translate}}</h4>
    <button [disabled]="false" type="button" value="Close" class="close" aria-label="Close" title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="dismiss()">
      <span class="icon-Close" aria-hidden="true" ></span>
    </button>
  </div>
  <div class="modal-body save-as-modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
    <div class="col-12">
      <form #saveAsForm>

        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-textbox #planNameInput
                          (wfmTextboxEvent)="setPlanName($event.target.value)"
                          inputName="planName"
                          (inputOnInput)="doOnInput()"
                          [maxLength]="32"
                          [wfmAutoComplete]="'off'"
                          inputId="planName"
                          [required]="true"
                          [textValue]=""
                          label="{{'plan.label.name'|translate}}"
                          hasFocus=true>
            </wfm-textbox>
          </div>
        </div>

        <div class="row" *ngIf="!isCXOne">
          <div class='col-8 col-sm-4 col-md-6 col-lg-5 col-xl-6 form-group' id="entity-type">
            <label class="text-uppercase input-label" for="entity-type">{{'plan.label.entitytype'|translate}}</label><br>
            <span>{{inEntityType}}</span>
          </div>
        </div>

        <div class="row" *ngIf="!isCXOne">
          <div class='col-8 col-sm-4 col-md-6 col-lg-5 col-xl-6 form-group' id="entity-name">
            <label class="text-uppercase input-label" for="entity-name">{{'plan.label.entity'|translate}}</label><br>
            <span>{{inEntityName}}</span>
          </div>
        </div>

        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group' id="fcst-name">
            <label class="text-uppercase input-label" for="fcst-name">{{'plan.label.forecast'|translate}}</label><br>
            <span>{{inLtfcstName}}</span>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="false"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.save.as.dlg.btn'|translate}}"
                     id="save-as-btn"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     placement="top"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
